<div class="position-relative selector-busqueda">
    <label class="form-label" [for]="inputId">{{ etiqueta }}</label>
    @if (seleccionada) {
        <div class="form-control selected-chip" data-testid="selector-seleccion">
            <span>{{ seleccionada.texto }}@if (seleccionada.inactiva) { <small class="text-muted"> (inactiva)</small> }</span>
            @if (!deshabilitado) {
                <button type="button" class="btn btn-link btn-sm p-0" [attr.aria-label]="'Cambiar ' + etiqueta.toLowerCase()" data-testid="selector-quitar" (click)="quitar()">Cambiar</button>
            }
        </div>
    } @else {
        <div class="input-group">
            @if (grupos.length) {
                <select class="form-select flex-grow-0 w-auto" [attr.aria-label]="etiquetaGrupo" data-testid="selector-grupo" [(ngModel)]="grupo" [disabled]="deshabilitado" (focus)="abrir()">
                    <option value="">Todos</option>
                    @for (g of grupos; track g.id) { <option [ngValue]="g.id">{{ g.texto }}</option> }
                </select>
            }
            <input type="text" [id]="inputId" class="form-control" [placeholder]="placeholder" autocomplete="off" role="combobox" aria-autocomplete="list"
                [attr.aria-expanded]="abierto" [disabled]="deshabilitado" data-testid="selector-input"
                [(ngModel)]="texto" (focus)="abrir()" (input)="abrir()" (keydown.escape)="cerrar()" (keydown.enter)="intro()">
        </div>
        @if (abierto) {
            <div class="list-group position-absolute w-100" style="z-index: 5; max-height: 18rem; overflow-y: auto;" role="listbox" data-testid="selector-lista">
                @if (cargando) {
                    <div class="list-group-item small text-muted" data-testid="selector-cargando">Cargando…</div>
                } @else if (error) {
                    <div class="list-group-item small text-danger d-flex justify-content-between align-items-center" data-testid="selector-error">
                        <span>{{ error }}</span>
                        <button type="button" class="btn btn-link btn-sm p-0" data-testid="selector-reintentar" (click)="reintentar.emit()">Reintentar</button>
                    </div>
                } @else if (!visibles.length) {
                    <div class="list-group-item small text-muted" data-testid="selector-vacio">No hay coincidencias.</div>
                } @else {
                    @for (o of visibles; track o.id) {
                        <button type="button" class="list-group-item list-group-item-action" role="option" data-testid="selector-opcion" (click)="elegir(o)">
                            <span class="d-block">{{ o.texto }}@if (o.inactiva) { <small class="text-muted"> (inactiva)</small> }</span>
                            @if (o.detalle) { <small class="text-muted">{{ o.detalle }}</small> }
                        </button>
                    }
                    @if (ocultas) {
                        <div class="list-group-item small text-muted" data-testid="selector-mas">Hay {{ ocultas }} coincidencias más: sigue escribiendo para acotar.</div>
                    }
                }
            </div>
        }
    }
</div>
